module.exports = __webpack_public_path__ + "img/05-Pic-03.a3c95dee.png";